export default "__VITE_ASSET__DABpzOdy__"